import React from 'react';

import { SheetHeader } from '@epoch-ui/components/Sheet/sheet';

import { useGuestSideSheetContext } from '../guestSideSheetContext';

export const ExternalGuestSideSheetHeader = (): React.ReactNode => {
  const {
    guestData: { guest }
  } = useGuestSideSheetContext();
  return (
    <SheetHeader>
      <div className="tw-flex tw-items-center tw-gap-4">
        <div className="tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-[2px]">
          <h3 className="tw-m-0 tw-text-xl tw-font-medium tw-leading-7">
            {guest.firstName} {guest.lastName} (Guest)
          </h3>
        </div>
      </div>
    </SheetHeader>
  );
};
